module.exports = __webpack_public_path__ + "img/kommande.3ce1b900.jpg";